import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import "umovme-vuejs-components/dist/lib/umovme-vuejs-components.min.css"

Vue.config.productionTip = false

locale.use(lang)

import {
  FormItem,
  Form,
  Select,
  Option,
  Checkbox,
  Autocomplete,
  Input,
  Row,
  Col,
  Container,
  Header,
  Main,
  Cascader,
  Button,
  Card,
  Switch,
  OptionGroup,
  Menu,
  MessageBox,
  Message
} from "element-ui"

Vue.use(FormItem)
Vue.use(Form)
Vue.use(Select)
Vue.use(Option)
Vue.use(Checkbox)
Vue.use(Autocomplete)
Vue.use(Input)
Vue.use(Input)
Vue.use(Row)
Vue.use(Col)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Cascader)
Vue.use(Button)
Vue.use(Card)
Vue.use(Switch)
Vue.use(OptionGroup)
Vue.use(Menu)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
